import { BaseService } from "../../core/baseService";
import {
  ModifierServiceInterface,
  ModifierGroup,
  Modifier,
  GetModifierGroupsParams,
  CreateModifierGroupParams,
  UpdateModifierGroupParams,
  DeleteModifierGroupParams,
  CreateModifierParams,
  UpdateModifierParams,
  DeleteModifierParams,
  GetModifierGroupsForMenuItemParams,
  AssignModifierGroupsToMenuItemParams,
} from "../types/modifier.types";
import { ApiResult } from "../../core/types";

export class ModifierService
  extends BaseService
  implements ModifierServiceInterface
{
  async getModifierGroups(
    params?: GetModifierGroupsParams,
  ): Promise<ApiResult<ModifierGroup[]>> {
    const queryParams = params?.includeInactive
      ? `?includeInactive=${params.includeInactive}`
      : "";
    return this.handleRequest<ModifierGroup[]>(
      this.client.get(`/api/admin/modifiers/groups${queryParams}`),
    );
  }

  async getModifierGroup(groupId: string): Promise<ApiResult<ModifierGroup>> {
    return this.handleRequest<ModifierGroup>(
      this.client.get(`/api/admin/modifiers/groups/${groupId}`),
    );
  }

  async createModifierGroup(
    params: CreateModifierGroupParams,
  ): Promise<ApiResult<ModifierGroup>> {
    return this.handleRequest<ModifierGroup>(
      this.client.post("/api/admin/modifiers/groups", params),
    );
  }

  async updateModifierGroup(
    params: UpdateModifierGroupParams,
  ): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.put(
        `/api/admin/modifiers/groups/${params.groupId}`,
        params.data,
      ),
    );
  }

  async deleteModifierGroup(
    params: DeleteModifierGroupParams,
  ): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(`/api/admin/modifiers/groups/${params.groupId}`),
    );
  }

  async createModifier(
    params: CreateModifierParams,
  ): Promise<ApiResult<Modifier>> {
    return this.handleRequest<Modifier>(
      this.client.post(
        `/api/admin/modifiers/groups/${params.groupId}/modifiers`,
        params.data,
      ),
    );
  }

  async updateModifier(params: UpdateModifierParams): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.put(
        `/api/admin/modifiers/modifiers/${params.modifierId}`,
        params.data,
      ),
    );
  }

  async deleteModifier(params: DeleteModifierParams): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(`/api/admin/modifiers/modifiers/${params.modifierId}`),
    );
  }

  async getModifierGroupsForMenuItem(
    params: GetModifierGroupsForMenuItemParams,
  ): Promise<ApiResult<ModifierGroup[]>> {
    return this.handleRequest<ModifierGroup[]>(
      this.client.get(`/api/admin/modifiers/items/${params.menuItemId}/groups`),
    );
  }

  async assignModifierGroupsToMenuItem(
    params: AssignModifierGroupsToMenuItemParams,
  ): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.put(
        `/api/admin/modifiers/items/${params.menuItemId}/groups`,
        params.assignments,
      ),
    );
  }
}
